import { render } from "./ErrorHandler.vue?vue&type=template&id=3886b08e"
import script from "./ErrorHandler.vue?vue&type=script&lang=js"
export * from "./ErrorHandler.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__